import React, { useEffect, useState } from 'react';
import { Package, Wrench } from 'lucide-react';
import { useApi } from '../../../pages/admin/purchasing/ui';

const inr = (n) => `₹${Number(n).toLocaleString('en-IN')}`;

// Adds a labour job (or a package of jobs) priced from the labour chart for the vehicle's segment.
export const LabourPicker = ({ vehicle, onPick, onPickMany }) => {
  const { call } = useApi();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [q, setQ] = useState('');
  const [tab, setTab] = useState('jobs');
  useEffect(() => {
    if (!open) return;
    const p = new URLSearchParams({ make: vehicle?.make || '', model: vehicle?.model || '', vtype: vehicle?.type || 'car', segment: vehicle?.labour_segment || '' });
    call('get', `/labour/for-vehicle?${p}`).then(setData).catch(() => {});
  }, [open, vehicle, call]);
  const match = (n) => !q || n.toLowerCase().includes(q.toLowerCase());
  const jobs = (data?.jobs || []).filter((j) => match(j.name)).slice(0, 60);
  const packs = (data?.packages || []).filter((p) => match(p.name) && p.jobs.length);
  const close = () => { setOpen(false); setQ(''); };
  const pickPack = (p) => { if (onPickMany) onPickMany(p.jobs, data.segment); else p.jobs.forEach((j) => onPick(j, data.segment)); close(); };
  const tabBtn = (k, label) => (
    <button type="button" onClick={() => setTab(k)} className={`rounded-full px-3 py-1 text-xs font-semibold ${tab === k ? 'bg-slate-900 text-white' : 'text-slate-600'}`} data-testid={`labour-picker-tab-${k}`}>{label}</button>
  );
  return (
    <div className="relative">
      <button type="button" onClick={() => setOpen((o) => !o)} className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-700 hover:border-slate-400" data-testid="labour-picker-btn">
        <Wrench size={13} /> Labour
      </button>
      {open && (
        <div className="absolute right-0 z-30 mt-1 w-96 rounded-xl border bg-white p-2 shadow-xl" data-testid="labour-picker">
          <p className="px-1 pb-1 text-[11px] text-slate-500" data-testid="labour-picker-segment">{data ? `${data.kind === 'bike' ? 'Two-wheeler' : 'Car'} · segment ${data.segment_name}${vehicle ? ` (${[vehicle.make, vehicle.model].filter(Boolean).join(' ')})` : ' (no vehicle picked)'}` : 'Loading…'}</p>
          <div className="mb-1 flex gap-1">{tabBtn('jobs', 'Jobs')}{tabBtn('packages', `Packages${data?.packages?.length ? ` (${data.packages.length})` : ''}`)}</div>
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder={tab === 'jobs' ? 'Search labour jobs' : 'Search packages'} className="mb-1 w-full rounded-lg border px-2 py-1.5 text-sm" data-testid="labour-picker-search" />
          <div className="max-h-72 overflow-y-auto">
            {tab === 'jobs' && jobs.map((j) => (
              <button key={j.id} type="button" onClick={() => { onPick(j, data.segment); close(); }} className="flex w-full items-center justify-between rounded-lg px-2 py-1.5 text-left text-sm hover:bg-teal-50" data-testid={`labour-pick-${j.id}`}>
                <span>{j.name}<span className="block text-[11px] text-slate-400">{j.category}</span></span>
                <span className={j.price == null ? 'text-slate-300' : 'font-semibold'}>{j.price == null ? '—' : inr(j.price)}</span>
              </button>))}
            {tab === 'packages' && packs.map((p) => (
              <button key={p.id} type="button" onClick={() => pickPack(p)} className="flex w-full items-start justify-between gap-2 rounded-lg px-2 py-1.5 text-left text-sm hover:bg-teal-50" data-testid={`labour-pick-package-${p.id}`}>
                <span className="flex gap-1.5"><Package size={14} className="mt-0.5 text-teal-700" /><span>{p.name}
                  <span className="block text-[11px] text-slate-400">{p.jobs.length} jobs{p.discount_pct ? ` · ${p.discount_pct}% off` : ''}{p.missing.length ? ` · ${p.missing.length} unpriced` : ''}</span></span></span>
                <span className="text-right"><b>{inr(p.price)}</b>{p.discount_pct > 0 && <s className="block text-[11px] text-slate-400">{inr(p.full_price)}</s>}</span>
              </button>))}
            {tab === 'packages' && !packs.length && <p className="px-2 py-4 text-center text-xs text-slate-500" data-testid="labour-picker-no-packages">No packages yet. Create them in Labour Chart.</p>}
          </div>
        </div>
      )}
    </div>
  );
};
